import { BuyerViewHistoryApi } from '@b-stock/buyer-personalization-api-client'
import { buildGetApiClient } from '@b-stock/fe-core/bstock-next/queries'

const getBuyerViewHistoryClient = buildGetApiClient(
  'PERSONALIZATION',
  BuyerViewHistoryApi
)

export default getBuyerViewHistoryClient
